import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import { UIButton, UIIcon, UIModal } from "../../../../ui";
import EventSummaryBox from "./EventSummaryBox";

import "./PublishEventModal.scss";

const PublishEventModal = ({
  open,
  onClose,
  onPublish,
  loading,
  eventSummary,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events, shared } = messages[lang];
  const t = events?.creatEvent?.publishEventModal;

  return (
    <UIModal
      className="publish-event-modal"
      open={open}
      onClose={loading ? undefined : onClose}
      title={null}
      showClose={false}
      maxWidth="xs"
      actions={null}
    >
      <div className="publish-event-modal__content">
        <div className="publish-event-modal__icon">
          <UIIcon name="rocket" width={40} height={40} />
        </div>

        <Typography className="publish-event-modal__title text-heading-md" component="h2">
          {t.title}
        </Typography>

        <Typography className="publish-event-modal__message text-body-sm" component="p">
          {t.messageStart} <strong>{t.messageHighlight}</strong>{" "}
          {t.messageEnd}
        </Typography>

        <EventSummaryBox eventSummary={eventSummary} />

        <div className="publish-event-modal__actions">
          <UIButton
            type="button"
            variant="outlined"
            color="inherit"
            onClick={onClose}
            disabled={loading}
          >
            {shared.cancel}
          </UIButton>
          <UIButton
            type="submit"
            appearance="gradient"
            onClick={onPublish}
            loading={loading}
          >
            {t.publishButton}
          </UIButton>
        </div>
      </div>
    </UIModal>
  );
};

PublishEventModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  eventSummary: PropTypes.shape({
    name: PropTypes.string,
    image_url: PropTypes.string,
    staffRequested: PropTypes.number,
  }),
};

PublishEventModal.defaultProps = {
  loading: false,
  eventSummary: {},
};

export default PublishEventModal;
